var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":_vm.onClick}},[_vm._t("default"),_c('div',{staticClass:"header"},[_vm._t("header")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }